<!--填空题-->
<template>
<div class="Fill">
    <el-form-item label="题目" required>
        <uEditor :content="formData.subject" ref="subject" @getUEditorContent="getUEditorSubjectContent"></uEditor>
    </el-form-item>

    <el-form-item label="答案" required>
        <p class="txt">若一个空有多个正确答案，每个答案间用分号分隔，学员答案匹配任意一个都算正确</p>

        <ul class="fill-input">
            <li v-for="(item, index) in finalanswer" :key="index">
                <div class="tag">{{index + 1}}</div>
                <el-input placeholder="请输入正确答案" v-model="item.name"></el-input>
                <div class="del" v-if="finalanswer.length > 1" @click="delOption(index)"><img
                    src="@/common/images/other/icon-del.png" alt="del"></div>
            </li>
            <el-button type="primary" plain @click="addOption">+ 新增答案</el-button>
            <!--  -->
        </ul>

    </el-form-item>

    <el-form-item>

    </el-form-item>
    <el-form-item label="答案匹配顺序">
        <el-radio v-model="formData.isquesorder" label="1">是</el-radio>
        <el-radio v-model="formData.isquesorder" label="0">否</el-radio>
        <p class="txt">答案不按顺序，只要答对就得分</p>
    </el-form-item>
    <el-form-item label="是否按空得分">
        <el-radio v-model="formData.isscorebyblank" label="1">是</el-radio>
        <el-radio v-model="formData.isscorebyblank" label="0">否</el-radio>
        <p class="txt">每空按总分数/空数计算得分</p>
    </el-form-item>
    <el-form-item label="试题解析">
        <uEditor :content="formData.quesanalysis" ref="quesanalysis"
                 @getUEditorContent="getUEditorQuesanalysisContent"></uEditor>
    </el-form-item>
    <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click='submit'>保存</el-button>
    </el-form-item>
</div>
</template>

<script>
import UEditor from 'base/uEditor/uEditor4'

export default {
    name: 'Fill',
    props: ['formData', 'type'],
    data() {
        return {
            finalanswer: [],
        }
    },
    mounted() {
        this._initFill()
    },
    methods: {
        _initFill() { // 初始化多选数据
            if (this.type == 2) {
                this.$nextTick(() => {
                    this.formData.isquesorder = this.formData.isquesorder.toString()
                    this.formData.isscorebyblank = this.formData.isscorebyblank.toString()
                    if (this.formData.finalanswerblank) {
                        for (let i = 0; i < this.formData.finalanswerblank.answerblank.length; i++) {
                            this.finalanswer.push({name: this.formData.finalanswerblank.answerblank[i]}) // name 答案名称
                        }
                    }
                })
            } else {
                this.formData.isquesorder = '0'
                this.formData.isscorebyblank = '1'
                this.finalanswer = []
                this.addOption()
            }
        },
        addOption() { // 增加新选项
            this.finalanswer.push({name: ''}) // name 答案名称
        },
        delOption(index) { // 删除选项 index 下标
            this.finalanswer.splice(index, 1)
        },
        getUEditorSubjectContent(content) {
            this.formData.subject = content
        },
        getUEditorQuesanalysisContent(content) {
            this.formData.quesanalysis = content
        },
        cancel() {  // 返回题库
            this.$emit('cancel')
        },
        submit() {
            let addfinalanswer = ''
            // 组装答案
            for (let i = 0; i < this.finalanswer.length; i++) {
                if (this.finalanswer[i].name == '' || this.finalanswer[i].name.length == 0) {
                    this.$message.error('答案不能为空')
                    return
                }
                addfinalanswer += this.finalanswer[i].name + '|'
            }
            addfinalanswer = addfinalanswer.substr(0, addfinalanswer.length - 1)
            this.formData.finalanswer = addfinalanswer
            this.$emit('childSubmitFormApi', JSON.stringify(this.formData))
        }
    },
    filters: {},
    watch: {
        formData() {
            this._initFill()
        }
    },
    computed: {},
    components: {
        UEditor
    }
}
</script>

<style lang="scss" type="text/scss" scope>
.Fill {
    .txt {
        font-size: 12px;
        color: #909399;
    }
    .uEditor {
        .ue_btn {
            display: none;
        }
    }
    .del {
        position: absolute;
        top: 0;
        right: -20px;
        cursor: pointer;
        img {
            width: 12px;
            height: 12px;
        }
    }
    .fill-input {
        li {
            position: relative;
        }
        .tag {
            // content: counter(number);
            // counter-reset: number 1;
            z-index: 5;
            width: 30px;
            height: 30px;
            position: absolute;
            left: 1px;
            top: 5px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            text-align: center;
            line-height: 32px;
            background: #E6F1FC;
        }
        // .el-input::before {
        //     content: counter(number);
        //     counter-reset: number 1;
        //     width: 30px;
        //     height: 30px;
        //     position: absolute;
        //     left: 1px;
        //     top: 5px;
        //     border-top-left-radius: 4px;
        //     border-bottom-left-radius: 4px;
        //     text-align: center;
        //     line-height: 32px;
        //     background: #E6F1FC;
        // }
        .el-input {
            .el-input__inner {
                padding-left: 42px;
            }
        }
    }

}
</style>
